import { Injectable } from "@angular/core";
import { finalize, tap } from "rxjs/operators";
import { HttpInterceptor, HttpHandler, HttpRequest } from "@angular/common/http";
import { Router } from "@angular/router";
import Swal from "sweetalert2";

/*
Purpose: to handle all API errors at single level 
*/
@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  constructor(private router: Router) { }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    //let clone: HttpRequest<any>;

    return next.handle(req).pipe(
      tap(
        event => {
          //console.log(event);
          this.onSuccess(event);
        },
        error => {
          //console.log(error);
          this.onError(error);
        }
      ),
      finalize(() => { })
    );
  }

  /* onSuccess() method will handle success response*/
  private onSuccess(event: any) { }

  /* onError() method will handle failure response*/
  private onError(error: any) {

    if (error.status == 400 || error.status == 403 || error.status == 404) {
      Swal.fire({
        type: "error",
        // title: error.error.message,
        text: error.error.data
      });

    } else if (error.status == 401) {
      localStorage.removeItem('x-auth-token');
      this.router.navigate(["/auth/signin"]);
    } else {
      Swal.fire({
        type: "error",
        // title: "Oops...",
        text: error.error.data || "Something went wrong!"
      });
    }

  }
}
